import { useEffect } from "react";
import { useLocation } from "react-router";
import { track } from "../api/tracking";

const usePageViewTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    track.pageView();
  }, [pathname]);
};

export default usePageViewTracker;
